import { ActualFileObject, FilePondFile } from "filepond";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { Tabs, Tab } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { FilePond } from "react-filepond";
import { useNavigate, useParams } from "react-router-dom";
import {
  IMPORT_MAPPING_URL,
  WORKFLOW_URL,
} from "../../../utils/helpers/api.routes";
import { WorkflowStepper } from "./WorkflowStepper";
import { WorkflowService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import ArrowIcon from "../../../shared/icons/down-arrow.svg";
import { ClientService } from "../../clients/service";
import { IExport } from "../../exports/dto/IExports";
import Select, { SingleValue } from "react-select";
import { themeSelect } from "../../../shared/components/Select2";
import { useDispatch, useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { IWorkflow } from "../dto/IWorkflow";
import { AttributesService } from "../../attributes/service";
import { IAttributes } from "../../attributes/names/dto/IAttributes";
import { BlockService } from "../../block/service";
import { IBlock } from "../../block/dto/IBlock";
import {
  formatDate,
  getCorrectLanguage,
} from "../../../shared/functions/Functions";
import { DocumentBlockService } from "../../blockDocument/service";
import { useTranslation } from "react-i18next";
import { EnumService } from "../../../store/enums/enumService";
import enumsSlice from "../../../store/enums/enumsRedux";
import { Helmet } from "react-helmet-async";

export const handleStepNavigate = (
  status: string,
  id: number,
  navigate: any
) => {
  switch (status) {
    case "SETTING_UP":
      return navigate(`/app/workflow/step1/${id}`);
    case "IMPORT":
      return navigate(`/app/workflow/step2/${id}`);
    case "BASE_DATA":
      return navigate(`/app/workflow/step3/${id}`);
    case "ATTRIBUTES":
      return navigate(`/app/workflow/step4/${id}`);
    case "MEDIA":
      return navigate(`/app/workflow/step-media/${id}`);
    case "COPY_WRITING":
      return navigate(`/app/workflow/step5/${id}`);
    case "TRANSLATION":
      return navigate(`/app/workflow/step6/${id}`);
    case "OVERVIEW":
      return navigate(`/app/workflow/step7/${id}`);
    case "EXPORT":
      return navigate(`/app/workflow/step8/${id}`);
    default:
      return navigate(`/app/workflow/step1/${id}`);
  }
};
export const WorkflowStep2 = () => {
  const { t } = useTranslation();
  const [clientList, setClientList] = useState<IExport[]>([]);
  const [name, setName] = useState<string>("");
  const workflowData = useSelector((state: IAllStates) => state.workflow);
  const [showText, setShowText] = useState<boolean>(false);
  const [selectName, setSelectName] = useState<any>({ value: 0, label: "" });
  const [names, setNames] = useState<any[]>([]);
  const [preview, setPreview] = useState({} as any);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const translationValue = [
    "title",
    "subtitle",
    "description",
    "intro",
    "bullets",
    "photo",
    "video",
    "link",
    "document",
  ];
  const separators = ["without", ";", ",", "\\", "|"];

  const [identificator, setIdentificator] = useState<number[]>([1]);
  const getCorrectSeparator = (separator: string, t: any) => {
    switch (separator) {
      case ";":
        return `${t(`separator.${separator}`)}`;
      case ",":
        return `${t(`separator.${separator}`)}`;
      case "|":
        return `${t(`separator.${separator}`)}`;
      case "\\":
        return `${t(`separator.${separator}`)}`;
      case "without":
        return `${t(`separator.${separator}`)}`;
      default:
        return `NULL - ${separator}`;
    }
  };
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const [mappingFile, setMappingFile] = useState<File>();
  const { translationLanguageEnum } = useSelector(
    (state: IAllStates) => state.enums
  );
  const [blockList, setBlockList] = useState<IBlock[] | undefined>();
  const [documentBlockList, setDocumentBlockList] = useState<
    IBlock[] | undefined
  >();
  const cellContentStyle: React.CSSProperties = {
    maxHeight: "45px",
    maxWidth: "100%",
    minWidth: "90px",
    overflowY: "auto",
    overflowX: "hidden",
    wordBreak: "break-word",
    display: "block",
    paddingRight: "1px",
    textAlign: "center",
  };
  const [showOverview, setShowOverview] = useState(false);
  const addedBlockField = [{ value: 0, label: t("document_block.main_value") }];
  const [attributesList, setAttributesList] = useState<IAttributes[]>([]);
  const [mappingArray, setMappingArray] = useState<any[]>([]);
  const [isLoadingScan, setIsLoadingScan] = useState(false);
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isLoadingImport, setIsLoadingImport] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [showResp, setShowResp] = useState(false);
  const [responseBack, setResponseBack] = useState({} as any);
  const [files, setFiles] = useState<ActualFileObject[]>([]);
  const [filesMapping, setFilesMapping] = useState<ActualFileObject[]>([]);
  const pondRef = useRef<FilePond>(null);
  const workflowDataRedux = useSelector((state: IAllStates) => state.workflow);
  const [statsChart, setStatsChart] = useState<any>();
  const [importStats, setImportStats] = useState<any[]>([]);
  const [showStats, setShowStats] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [selectedStats, setSelectedStats] = useState<any>(null);

  const uniqueOptions = [
    "ean",
    "article_number",
    "sap_id",
    "category",
    "brand",
    "source_url",
    "pharma_code",
  ];
  const functionForCorrectFields = (item: any): JSX.Element[] => {
    const arr = item?.translations?.map((differentLang: any) =>
      Object?.keys(differentLang)?.filter((key: any) =>
        translationValue?.includes(key)
      )
    );

    return (
      item?.translations?.map(
        (field: any, index: number) =>
          arr[0]?.map((colName: string, inx: number) => (
            <td
              className="text-start"
              key={`${colName}-${index}-${inx}`}
              style={{
                backgroundColor: field?.[colName]?.isLoadedFromDatabase
                  ? "#f8ed62"
                  : "#90EE90",
              }}
            >
              <div style={cellContentStyle}>
                {Array?.isArray(field?.[colName]?.value)
                  ? colName === "photo" ||
                    colName === "video" ||
                    colName === "link"
                    ? field?.[colName]?.value?.map((item: any, i: number) => (
                        <span key={i} className="d-block">
                          {item?.text ? (
                            <>
                              <span className="d-block">{item?.text}</span>
                              <span className="text-nowrap">
                                {item?.hyperlink}
                              </span>
                            </>
                          ) : (
                            <span className="d-block text-nowrap">{item}</span>
                          )}
                        </span>
                      ))
                    : field?.[colName]?.value?.map((item: any, j: number) => (
                        <span key={j} className="d-block">
                          {item?.link ?? item ?? item?.text}
                        </span>
                      ))
                  : field?.[colName]?.excelValue ?? ""}
              </div>
            </td>
          )) ?? []
      ) ?? []
    );
  };

  const handleSelectMapping = (
    selectedSingle: SingleValue<{ label: string; value: any }>,
    index: number,
    field: string,
    columnName = ""
  ) => {
    if (selectedSingle?.value === undefined) {
      field === "mapTo"
        ? setMappingArray((prev: any) => {
            const newItems = [...prev];
            newItems[index] = {
              ...newItems[index],
              ["mapTo"]: null,
              ["value"]: null,
              ["language"]: null,
            };
            return newItems;
          })
        : setMappingArray((prev: any) => {
            const newItems = [...prev];
            newItems[index] = {
              ...newItems[index],
              [field]: null,
            };
            return newItems;
          });
    } else {
      setMappingArray((prev: any) => {
        const newItems = [...prev];
        newItems[index] = {
          ...newItems[index],
          [field]: selectedSingle?.value,
        };
        return newItems;
      });
    }
    if (columnName === "identificator") {
      const lastValue = identificator?.length;
      if (identificator[lastValue - 1] === selectedSingle?.value) {
        identificator?.push(selectedSingle?.value + 1);
      }
    }
  };
  const handleProcess = () => {
    if (pondRef.current) {
      setIsLoadingScan(true);
      pondRef.current.processFiles();
    }
  };
  const handleSave = () => {
    WorkflowService.saveWorkflowImportById(Number(id))
      .then((response) => {
        const status = response?.status;
        handleStepNavigate(status, Number(id), navigate);
      })
      .catch((error) => ErrorToast(error));
  };
  // const handleImportOverview = () => {
  //   WorkflowService.saveWorkflowImportById(Number(id))
  //     .then((response) => {
  //       const status = response?.status;
  //       handleStepNavigate(status, Number(id), navigate);
  //     })
  //     .catch((error) => ErrorToast(error));
  // };
  const backNavigate = () => {
    navigate(`/app/workflow`);
  };
  function capitalizeFirstLetter(str: string) {
    if (!str) return str;
    return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
  }
  useEffect(() => {
    ClientService.getAllClients({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setClientList(
          data?.map((client) => ({
            ...client,
            label: client.name,
            value: client.id,
          }))
        );
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    DocumentBlockService.getAllBlocks({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        const res = data?.map((item: any) => {
          return {
            value: item?.id,
            label: item?.name,
          };
        });
        const merged = [...addedBlockField, ...res];
        setDocumentBlockList(merged as any);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  const languageVisible = (item: string) => {
    if (
      item === "ean" ||
      item === "article_number" ||
      item === "sap_id" ||
      item === "category" ||
      item === "brand" ||
      item === "source_url" ||
      item === "pharma_code"
    ) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    AttributesService.getAllAttributes({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const res = response?.data?.map((item: any) => {
          return {
            value: item?.id,
            label: item?.title,
          };
        });
        setAttributesList(res as any);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    BlockService.getAllBlocks({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        const resBlock = data?.map((item: any) => {
          return {
            value: item?.id,
            label: item?.name,
          };
        });
        setBlockList(resBlock as any);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    WorkflowService.getAllImportMapping(Number(id))
      .then((response) => {
        setNames(response);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    if (id) {
      WorkflowService.getMappedImportStatistics(Number(id))
        .then((response) => {
          setImportStats(response);
        })
        .catch((error) => ErrorToast(error));
    }
  }, [id]);

  const findUniqueInArray1 = (arr1: any[], arr2: any[]) => {
    return arr1?.filter((item) => !arr2?.includes(item));
  };
  // const findUniqueInArrayWithValue = (arr1: any[], arr2: any[]) => {
  //   return arr1.filter((item) => !arr2?.includes(item?.value));
  // };
  const findUniqueInLangauge = (arr1: any[], arr2: any[]) => {
    const arrCorrect = arr2?.map((item: any) => {
      return item?.language;
    });
    return arr1.filter((item) => !arrCorrect?.includes(item));
  };
  const filterArrayDocumentValue = (arr1: any[], arr2: any[]): any[] => {
    // Mapa za brojanje pojavljivanja elemenata u arr2
    const countMap = new Map<any, number>();
    // Mapa sa brojem pojavljivanja elemenata iz arr2
    for (const item of arr2) {
      if (countMap.has(item)) {
        countMap.set(item, countMap.get(item)! + 1);
      } else {
        countMap.set(item, 1);
      }
    }
    // Uklanja elemente koji se pojavljuju 4 puta u arr2
    return arr1.filter((item) => countMap.get(item) !== 4);
  };
  //------------------------------------------------------------------------------
  const funcForRepeatLanguageField = (item: any) => {
    const sameFields = (mappingArray as any)?.filter(
      (itemMap: any) => itemMap.mapTo?.toLowerCase() == item?.mapTo
    );
    const allLangaugeFields = sameFields?.filter(
      (filed: any) => filed?.value === item?.value
    );
    if (allLangaugeFields?.length === 0) {
      return (translationLanguageEnum as any)?.map((language: string) => ({
        value: language,
        label: getCorrectLanguage(language, t),
      }));
    } else {
      return findUniqueInLangauge(translationLanguageEnum, allLangaugeFields);
    }
  };
  const funcForLanguageField = (item: any) => {
    const currentField = item?.mapTo;
    const sameFields = (mappingArray as any)?.filter(
      (itemMap: any) => itemMap.mapTo?.toLowerCase() == currentField
    );
    if (currentField === "block") {
      const allValueFields = sameFields
        ?.filter((item: any) => item?.value !== null)
        ?.map((item: any) => {
          return item?.value;
        });
      // if (allValueFields?.length === 0) {
      return (blockList as any)?.map((item: any) => ({
        value: item?.value,
        label: item?.label,
      }));
      // } else {
      //   return findUniqueInArrayWithValue(blockList as any[], allValueFields);
      // }
    } else if (currentField === "document") {
      const allValueFields = sameFields
        ?.filter((item: any) => item?.value !== null)
        ?.map((item: any) => {
          return item?.value;
        });

      // if (allValueFields?.length === 0) {
      return (documentBlockList as any)?.map((item: any) => ({
        value: item?.value,
        label: item?.label,
      }));
      // } else {
      //   return filterArrayDocumentValue(
      //     documentBlockList as any[],
      //     allValueFields
      //   );
      // }
    } else if (currentField === "attribute_new") {
      const allValueFields = sameFields
        ?.filter((item: any) => item?.value !== null)
        ?.map((item: any) => {
          return item?.value;
        });
      if (allValueFields?.length === 0) {
        return identificator;
      } else {
        return filterArrayDocumentValue(identificator as any[], allValueFields);
      }
    } else if (currentField === "attribute") {
      const allValueFields = sameFields
        ?.filter((item: any) => item?.value !== null)
        ?.map((item: any) => {
          return item?.value;
        });

      // if (allValueFields?.length === 0) {
      return (attributesList as any)?.map((item: any) => ({
        value: item?.value,
        label: item?.label,
      }));
      // } else {
      //   return findUniqueInArrayWithValue(
      //     attributesList as any[],
      //     allValueFields
      //   );
      // }
    } else {
      const allLangaugeFields = sameFields?.map((item: any) => {
        return item?.language;
      });
      if (allLangaugeFields?.length === 0) {
        return (translationLanguageEnum as any)?.map((language: string) => ({
          value: language,
          label: getCorrectLanguage(language, t),
        }));
      } else {
        return findUniqueInArray1(translationLanguageEnum, allLangaugeFields);
      }
    }
  };
  const documentLanguageFields = (item: any) => {
    const sameFields = (mappingArray as any)?.filter(
      (itemMap: any) => itemMap.mapTo?.toLowerCase() == "document"
    );
    const allLangaugeFields = sameFields?.filter(
      (filed: any) => filed?.value === item?.value
    );
    if (allLangaugeFields?.length === 0) {
      return (translationLanguageEnum as any)?.map((language: string) => ({
        value: language,
        label: getCorrectLanguage(language, t),
      }));
    } else {
      return findUniqueInLangauge(translationLanguageEnum, allLangaugeFields);
    }
  };

  // const createImportMapping = (e: any) => {
  //   e.preventDefault();
  //   WorkflowService.createImportMapping(
  //     {
  //       name: name,
  //       fields: mappingArray,
  //     },
  //     Number(id)
  //   )
  //     .then((response) => {
  //       SuccessToast("Success create");
  //     })
  //     .catch((error) => ErrorToast(error));
  // };

  const newUpdateImportMapping = (e: any) => {
    e.preventDefault();
    setIsLoadingUpdate(true);
    WorkflowService.newUpdateImportMapping(
      {
        name: name,
        fields: mappingArray,
      },
      Number(id)
    )
      .then((response) => {
        // SuccessToast("Success updated");
        SuccessToast(t("toasts.successfully_updated"));
      })
      .catch((error) => ErrorToast(error))
      .finally(() => setIsLoadingUpdate(false));
  };
  const newMapImportMapping = (e: any) => {
    e.preventDefault();
    setIsLoadingMap(true);
    WorkflowService.newMapImportMapping(
      {
        name: name,
        fields: mappingArray,
      },
      Number(id)
    )
      .then((response) => {
        setMappingArray(response?.fields);
        const sameFields = (response?.fields as any)?.filter(
          (itemMap: any) => itemMap.mapTo?.toLowerCase() == "attribute_new"
        );
        // SuccessToast("Success mapped");
        SuccessToast(t("toasts.successfully_mapped"));
        const numbers = sameFields?.map((item: any) => Number(item?.value));
        if (!numbers[0]) {
          return;
        } else {
          let uniqueSortedNumbers = [
            ...(new Set(numbers) as unknown as number[]),
          ].sort((a, b) => a - b);

          let nextNumber =
            uniqueSortedNumbers[uniqueSortedNumbers.length - 1] + 1;
          uniqueSortedNumbers.push(nextNumber);
          if (uniqueSortedNumbers) setIdentificator(uniqueSortedNumbers);
        }
      })
      .catch((error) => ErrorToast(error))
      .finally(() => setIsLoadingMap(false));
  };

  const handlePreview = (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    mappingFile && formData.append("file", mappingFile);

    formData.append(
      "body",
      JSON.stringify({
        name: name,
        fields: mappingArray,
      })
    );
    WorkflowService.previewImportMapping(formData)
      .then((response) => {
        setPreview(response);
        handleShow();
      })
      .catch((error) => ErrorToast(error));
  };
  const handleImport = (e: any) => {
    e.preventDefault();
    setIsLoadingImport(true);
    const formData = new FormData();
    mappingFile && formData.append("file", mappingFile);
    formData.append(
      "body",
      JSON.stringify({
        name: name,
        fields: mappingArray,
      })
    );
    WorkflowService.importMapping(formData, Number(id))
      .then((response) => {
        // SuccessToast("Success imported!");
        SuccessToast(t("toasts.successfully_imported"));
      })
      .catch((error) => ErrorToast(error))
      .finally(() => setIsLoadingImport(false));
  };

  const getFilteredOptions = (backArr: string[]) => {
    const selectedValues = mappingArray
      .map((item) => item.mapTo)
      .filter(Boolean);
    return backArr
      .map((field: string) => ({
        value: field.toLowerCase(),
        label: capitalizeFirstLetter(field)?.replace("_", " "),
      }))
      .filter((option) => {
        return (
          !uniqueOptions.includes(option?.value) ||
          !selectedValues.includes(option?.value)
        );
      });
  };
  useEffect(() => {
    EnumService.getEnums().then((data) => {
      dispatch(enumsSlice.actions.setEnums(data));
    });
  }, []);
  useEffect(() => {
    WorkflowService.getWorkflowGeneralStatistics(Number(id))
      .then((response) => {
        setStatsChart(response);
      })
      .catch((error) => ErrorToast(error));
  }, []);

  return (
    <>
      <Card>
        <Card.Body>
          <Helmet>
            <title>
              {workflowData?.name ?? "-"} {t("workflow.IMPORT")}
            </title>
          </Helmet>
          <WorkflowStepper step={"IMPORT"} id={id}></WorkflowStepper>
          <Row>
            <div className="d-flex justify-content-between align-items-center">
              <Button
                variant="info"
                className="d-flex align-items-start justify-content-start"
                onClick={() => {
                  backNavigate();
                }}
              >
                <i className="ri-arrow-left-line me-1" />
                {`${t("block.back")}`}
              </Button>
              <div>
                <Button
                  variant="primary"
                  className="ms-3"
                  disabled={
                    !statsChart || statsChart?.statisticsHistory?.length === 0
                  }
                  onClick={() => {
                    setShowOverview((prev: boolean) => !prev);
                    setTimeout(() => {
                      window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: "smooth",
                      });
                    }, 0);
                  }}
                >
                  {t("requirement.import_overview")}
                </Button>
                <Button
                  variant="primary"
                  className="my-3 ms-3"
                  onClick={() => setShowStats((prev) => !prev)}
                >
                  {t("importStatistics.importStatistics")}
                </Button>
              </div>
            </div>
          </Row>
          <Row>
            <div className="col-6">
              <div className="d-flex align-items-center justify-content-center">
                <p className="mb-0">{t("import.excel_simple_file")}</p>
                <span className="ms-1 d-flex align-items-center">
                  {" "}
                  <a
                    href="/importTemplate.xlsx"
                    download
                    className="me-auto text-decoration-underline"
                  >
                    {t("import.download")}
                  </a>
                  <i className="ri-folder-download-line ms-1"></i>
                </span>
              </div>
              <FilePond
                className="my-0"
                files={files}
                allowReorder={true}
                labelFileProcessingError={`${t(
                  "toasts.filePondImport.error_mess"
                )}`}
                allowMultiple={true}
                server={{
                  process: (
                    fieldName,
                    file,
                    metadata,
                    load,
                    error,
                    progress,
                    abort
                  ) => {
                    const formData = new FormData();
                    formData.append(fieldName, file, file.name);

                    const request = new XMLHttpRequest();
                    request.open("PUT", `${WORKFLOW_URL}/${id}/upload`);
                    localStorage.getItem("token");

                    request.setRequestHeader(
                      "app-version",
                      `${localStorage.getItem("appVersion")}` || ""
                    );
                    request.setRequestHeader(
                      "Authorization",
                      `Bearer ${localStorage.getItem("token")}` || ""
                    );
                    request.upload.onprogress = (e) => {
                      progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function (e: any) {
                      if (request.status >= 200 && request.status < 300) {
                        const response = JSON.parse(request?.response);
                        setResponseBack(response);
                        setShowResp(true);
                        load(request.responseText);
                      } else {
                        error("Error onload");
                      }
                    };

                    request.send(formData);

                    return {
                      abort: () => {
                        request.abort();

                        abort();
                      },
                    };
                  },
                }}
                onupdatefiles={(filesArr: FilePondFile[]) => {
                  setFiles(filesArr?.map((fileItem) => fileItem?.file));
                }}
                labelIdle={`${t("import.drag_and_drop_normal")}`}
              />
              {showResp && (
                <>
                  <div className="d-flex justify-content-center">
                    {responseBack?.message}
                  </div>
                  <div className="d-flex justify-content-center">
                    <p className="me-1">
                      {t("import.successfully_added_rows")}{" "}
                      {responseBack?.successfullyAddedRows}
                    </p>
                    <p className="ms-1">
                      {t("import.skipped")} {responseBack?.skipped}
                    </p>
                  </div>
                </>
              )}
            </div>
            <div className="col-6" style={{ marginTop: "19.5px" }}>
              <FilePond
                ref={pondRef}
                className="my-0"
                files={filesMapping}
                allowReorder={true}
                instantUpload={false}
                allowMultiple={true}
                allowProcess={false}
                server={{
                  process: (
                    fieldName,
                    file,
                    metadata,
                    load,
                    error,
                    progress,
                    abort
                  ) => {
                    const formData = new FormData();
                    formData.append("file", file, file.name);
                    setMappingFile(file as any);
                    const request = new XMLHttpRequest();
                    request.open(
                      "POST",
                      `${IMPORT_MAPPING_URL}mapping-recommendation/${id}`
                    );

                    request.setRequestHeader(
                      "app-version",
                      `${localStorage.getItem("appVersion")}` || ""
                    );
                    request.setRequestHeader(
                      "Authorization",
                      `Bearer ${localStorage.getItem("token")}` || ""
                    );

                    request.upload.onprogress = (e) => {
                      progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                      if (request.status >= 200 && request.status < 300) {
                        const response = JSON.parse(request.response);
                        setMappingArray(response);
                        load(request.responseText);
                      } else {
                        error("Error onload");
                      }
                      setIsLoadingScan(false);
                    };

                    request.onerror = function () {
                      error("Error on request");
                    };

                    request.send(formData);

                    return {
                      abort: () => {
                        request.abort();
                        abort();
                      },
                    };
                  },
                }}
                onupdatefiles={(filesArr) => {
                  setFilesMapping(filesArr.map((fileItem) => fileItem.file));
                }}
                labelIdle={`${t("import.drag_and_drop_mapping")}`}
              />
            </div>
          </Row>

          <Row>
            <Col sm={10}>
              {!!mappingArray?.length && (
                <Row>
                  {mappingArray?.map((item: any, index: number) => (
                    <div className="col-md-2 d-flex flex-column my-3 mapping-import">
                      <textarea
                        // type="text"
                        value={item?.identifier + "-" + " " + item?.name}
                        className="w-100 dark-text-area"
                        rows={1}
                        style={{
                          width: "100%",
                          height: "28px",
                          overflowY: "hidden",
                          overflowX: "auto",
                          whiteSpace: "nowrap",
                        }}
                        disabled
                      />
                      <img
                        src={ArrowIcon}
                        style={{ height: "35px" }}
                        className="my-1"
                        alt="arrow-icon"
                      />
                      <Select
                        key={item?.mapTo}
                        styles={{
                          control: (base: any) => ({
                            ...base,
                            height: 30,
                            minHeight: 30,
                            backgroundColor: `${
                              item?.mapTo === null ? "#ffff89" : "#ffffff"
                            }`,
                          }),
                        }}
                        className="my-2"
                        theme={themeSelect}
                        placeholder={t("mapping.mapping_value")}
                        isClearable={true}
                        defaultValue={
                          item?.mapTo !== null && {
                            value: item?.mapTo.toLowerCase(),
                            label: capitalizeFirstLetter(item?.mapTo)?.replace(
                              "_",
                              " "
                            ),
                          }
                        }
                        onChange={(e) => {
                          handleSelectMapping(
                            e as any,
                            index as number,
                            "mapTo"
                          );
                        }}
                        options={getFilteredOptions(item.fields)}
                      />
                      {item?.mapTo === "attribute" ? (
                        <>
                          <Select
                            key={`attribute-${index}`}
                            styles={{
                              control: (base: any) => ({
                                ...base,
                                height: 30,
                                minHeight: 30,
                                backgroundColor: `${
                                  item?.value === null ? "#ffff89" : "#ffffff"
                                }`,
                              }),
                            }}
                            className="my-2"
                            defaultValue={attributesList.find(
                              (attribute: any) =>
                                attribute?.value == item?.value
                            )}
                            theme={themeSelect}
                            placeholder={t("mapping.attribute")}
                            isClearable={true}
                            onChange={(e) => {
                              handleSelectMapping(
                                e as any,
                                index as number,
                                "value"
                              );
                            }}
                            options={
                              funcForLanguageField && funcForLanguageField(item)
                            }
                          />
                          {true && (
                            <Select
                              key={`${item?.mapTo}-language-${index}`}
                              styles={{
                                control: (base: any) => ({
                                  ...base,
                                  height: 30,
                                  minHeight: 30,
                                  backgroundColor: `${
                                    !item?.language ? "#ffff89" : "#ffffff"
                                  }`,
                                }),
                              }}
                              className="my-2"
                              defaultValue={
                                item?.language && {
                                  value: item?.language,
                                  label: getCorrectLanguage(item?.language, t),
                                }
                              }
                              theme={themeSelect}
                              placeholder={t("global.language")}
                              onChange={(e) => {
                                handleSelectMapping(
                                  e as any,
                                  index as number,
                                  "language"
                                );
                              }}
                              // options={(translationLanguageEnum as any)?.map(
                              //   (language: string) => ({
                              //     value: language,
                              //     label: getCorrectLanguage(language, t),
                              //   })
                              // )}
                              options={(
                                funcForRepeatLanguageField &&
                                funcForRepeatLanguageField(item)
                              )?.map((language: string) => ({
                                value: language,
                                label: getCorrectLanguage(language, t),
                              }))}
                            />
                          )}
                          {true && (
                            <Select
                              key={`${item?.mapTo}-separator-${index}`}
                              // isClearable={true}
                              styles={{
                                control: (base: any) => ({
                                  ...base,
                                  height: 30,
                                  minHeight: 30,
                                  backgroundColor: `${"#ffffff"}`,
                                }),
                              }}
                              className="my-2"
                              defaultValue={
                                item?.separator
                                  ? {
                                      value: item?.separator,
                                      label: getCorrectSeparator(
                                        item?.separator,
                                        t
                                      ),
                                    }
                                  : {
                                      value: null,
                                      label: getCorrectSeparator("without", t),
                                    }
                              }
                              theme={themeSelect}
                              placeholder={t("mapping.separator")}
                              onChange={(e) => {
                                handleSelectMapping(
                                  e as any,
                                  index as number,
                                  "separator"
                                );
                              }}
                              options={(separators as any)?.map(
                                (separator: string) => ({
                                  value: separator,
                                  label: getCorrectSeparator(separator, t),
                                })
                              )}
                            />
                          )}
                        </>
                      ) : item?.mapTo === "photo" ||
                        item?.mapTo === "video" ||
                        item?.mapTo === "link" ? (
                        <Select
                          key={`${item?.mapTo}-${index}`}
                          // styles={customStyles}
                          styles={{
                            control: (base: any) => ({
                              ...base,
                              height: 30,
                              minHeight: 30,
                              backgroundColor: `${
                                !item?.language ? "#ffff89" : "#ffffff"
                              }`,
                            }),
                          }}
                          className="my-2"
                          defaultValue={
                            item?.language && {
                              value: item?.language,
                              label: getCorrectLanguage(item?.language, t),
                            }
                          }
                          theme={themeSelect}
                          placeholder={t("global.language")}
                          onChange={(e) => {
                            handleSelectMapping(
                              e as any,
                              index as number,
                              "language"
                            );
                          }}
                          options={(translationLanguageEnum as any)?.map(
                            (language: string) => ({
                              value: language,
                              label: getCorrectLanguage(language, t),
                            })
                          )}
                        />
                      ) : item?.mapTo === "block" ? (
                        <>
                          <Select
                            key={`block-${index}`}
                            // styles={customStyles}
                            styles={{
                              control: (base: any) => ({
                                ...base,
                                height: 30,
                                minHeight: 30,
                                backgroundColor: `${
                                  item?.value === null ? "#ffff89" : "#ffffff"
                                }`,
                              }),
                            }}
                            className="react-select-field my-2"
                            theme={themeSelect}
                            defaultValue={(blockList as any).find(
                              (block: any) => block?.value == item?.value
                            )}
                            placeholder={t("side_bar.block")}
                            isClearable={true}
                            onChange={(e) => {
                              handleSelectMapping(
                                e as any,
                                index as number,
                                "value"
                              );
                            }}
                            options={
                              funcForLanguageField && funcForLanguageField(item)
                            }
                          />
                          {true && (
                            <Select
                              key={`${item?.mapTo}-${index}`}
                              styles={{
                                control: (base: any) => ({
                                  ...base,
                                  height: 30,
                                  minHeight: 30,
                                  backgroundColor: `${
                                    !item?.language ? "#ffff89" : "#ffffff"
                                  }`,
                                }),
                              }}
                              className="my-2"
                              defaultValue={
                                item?.language && {
                                  value: item?.language,
                                  label: getCorrectLanguage(item?.language, t),
                                }
                              }
                              theme={themeSelect}
                              placeholder={t("global.language")}
                              onChange={(e) => {
                                handleSelectMapping(
                                  e as any,
                                  index as number,
                                  "language"
                                );
                              }}
                              options={(
                                funcForRepeatLanguageField &&
                                funcForRepeatLanguageField(item)
                              )?.map((language: string) => ({
                                value: language,
                                label: getCorrectLanguage(language, t),
                              }))}
                            />
                          )}
                        </>
                      ) : item?.mapTo === "attribute_new" ? (
                        <>
                          <Select
                            key={`attribute-new-${index}`}
                            // styles={customStyles}
                            styles={{
                              control: (base: any) => ({
                                ...base,
                                height: 30,
                                minHeight: 30,
                                backgroundColor: `${
                                  item?.value === null ? "#ffff89" : "#ffffff"
                                }`,
                              }),
                            }}
                            className="react-select-field my-2"
                            theme={themeSelect}
                            defaultValue={
                              !!item?.value && {
                                value: Number(item?.value),
                                label: item?.value,
                              }
                            }
                            placeholder={t("mapping.identificator")}
                            isClearable={true}
                            onChange={(e) => {
                              handleSelectMapping(
                                e as any,
                                index as number,
                                "value",
                                "identificator"
                              );
                            }}
                            options={(
                              funcForLanguageField && funcForLanguageField(item)
                            )?.map((identificator: string) => ({
                              value: identificator,
                              label: identificator,
                            }))}
                          />
                          {true && (
                            <Select
                              key={`${item?.mapTo}-language-${index}`}
                              styles={{
                                control: (base: any) => ({
                                  ...base,
                                  height: 30,
                                  minHeight: 30,
                                  backgroundColor: `${
                                    !item?.language ? "#ffff89" : "#ffffff"
                                  }`,
                                }),
                              }}
                              className="my-2"
                              defaultValue={
                                item?.language && {
                                  value: item?.language,
                                  label: getCorrectLanguage(item?.language, t),
                                }
                              }
                              theme={themeSelect}
                              placeholder={t("global.language")}
                              onChange={(e) => {
                                handleSelectMapping(
                                  e as any,
                                  index as number,
                                  "language"
                                );
                              }}
                              options={(
                                funcForRepeatLanguageField &&
                                funcForRepeatLanguageField(item)
                              )?.map((language: string) => ({
                                value: language,
                                label: getCorrectLanguage(language, t),
                              }))}
                            />
                          )}
                          {true && (
                            <Select
                              key={`${item?.mapTo}-separator-${index}`}
                              // isClearable={true}
                              styles={{
                                control: (base: any) => ({
                                  ...base,
                                  height: 30,
                                  minHeight: 30,
                                  backgroundColor: `${"#ffffff"}`,
                                }),
                              }}
                              className="my-2"
                              defaultValue={
                                item?.separator
                                  ? {
                                      value: item?.separator,
                                      label: getCorrectSeparator(
                                        item?.separator,
                                        t
                                      ),
                                    }
                                  : {
                                      value: null,
                                      label: getCorrectSeparator("without", t),
                                    }
                              }
                              theme={themeSelect}
                              placeholder={t("mapping.separator")}
                              onChange={(e) => {
                                handleSelectMapping(
                                  e as any,
                                  index as number,
                                  "separator"
                                );
                              }}
                              options={(separators as any)?.map(
                                (separator: string) => ({
                                  value: separator,
                                  label: getCorrectSeparator(separator, t),
                                })
                              )}
                            />
                          )}
                        </>
                      ) : item?.mapTo === "document" ? (
                        <>
                          {
                            <Select
                              key={`document-${index}`}
                              styles={{
                                control: (base: any) => ({
                                  ...base,
                                  height: 30,
                                  minHeight: 30,
                                  backgroundColor: `${
                                    item?.value === null ? "#ffff89" : "#ffffff"
                                  }`,
                                }),
                              }}
                              className="react-select-field my-2"
                              theme={themeSelect}
                              defaultValue={(documentBlockList as any).find(
                                (block: any) => block?.value == item?.value
                              )}
                              placeholder={capitalizeFirstLetter(item?.mapTo)}
                              isClearable={true}
                              onChange={(e) => {
                                handleSelectMapping(
                                  e as any,
                                  index as number,
                                  "value"
                                );
                              }}
                              options={
                                funcForLanguageField &&
                                funcForLanguageField(item)
                              }
                            />
                          }
                          {true && (
                            <>
                              <Select
                                key={`languageDocument-${index}`}
                                styles={{
                                  control: (base: any) => ({
                                    ...base,
                                    height: 30,
                                    minHeight: 30,
                                    backgroundColor: `${
                                      item?.language ? "#ffffff" : "#ffff89"
                                    }`,
                                  }),
                                }}
                                className="react-select-field my-2"
                                theme={themeSelect}
                                placeholder={t("global.language")}
                                onChange={(e) => {
                                  handleSelectMapping(
                                    e as any,
                                    index as number,
                                    "language"
                                  );
                                }}
                                defaultValue={
                                  item?.language && {
                                    value: item?.language,
                                    label: getCorrectLanguage(
                                      item?.language,
                                      t
                                    ),
                                  }
                                }
                                options={(translationLanguageEnum as any)?.map(
                                  (language: string) => ({
                                    value: language,
                                    // label: getCorrectLanguage(language, t),
                                    label: getCorrectLanguage(language, t),
                                  })
                                )}
                              />
                            </>
                          )}
                        </>
                      ) : (
                        item?.mapTo !== null &&
                        languageVisible(item?.mapTo) && (
                          <Select
                            key={`language-${index}`}
                            styles={{
                              control: (base: any) => ({
                                ...base,
                                height: 30,
                                minHeight: 30,
                                backgroundColor: `${
                                  item?.language === null
                                    ? "#ffff89"
                                    : "#ffffff"
                                }`,
                              }),
                            }}
                            className="react-select-field my-2"
                            theme={themeSelect}
                            placeholder={t("global.language")}
                            onChange={(e) => {
                              handleSelectMapping(
                                e as any,
                                index as number,
                                "language"
                              );
                            }}
                            defaultValue={
                              item?.language && {
                                value: item?.language,
                                label: getCorrectLanguage(item?.language, t),
                              }
                            }
                            options={(
                              funcForLanguageField && funcForLanguageField(item)
                            )?.map((language: string) => ({
                              value: language,
                              label: getCorrectLanguage(language, t),
                            }))}
                          />
                        )
                      )}
                    </div>
                  ))}
                </Row>
              )}
            </Col>

            <Col sm={2}>
              <div className="import-button-section">
                {filesMapping?.length !== 0 && (
                  <div className="border py-3 px-1">
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="info"
                        onClick={handleProcess}
                        disabled={filesMapping?.length === 0 || isLoadingScan}
                        className=""
                        style={{
                          minWidth: "67px",
                        }}
                      >
                        {isLoadingScan ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          <span> {t("global.scan")}</span>
                        )}
                        {/* {`${t("global.scan")}`} */}
                      </Button>
                    </div>
                    <Col md={12}>
                      <Select
                        key={workflowDataRedux?.id}
                        className="react-select-field my-2"
                        theme={themeSelect}
                        isDisabled={true}
                        defaultValue={{
                          label: workflowDataRedux?.client?.name,
                          value: workflowDataRedux?.client?.id,
                        }}
                      />
                    </Col>
                    <Col md={12} className="d-flex justify-content-end">
                      <Button
                        disabled={!!!mappingArray?.length || isLoadingUpdate}
                        variant="warning"
                        className="mx-1"
                        onClick={(e: any) => newUpdateImportMapping(e)}
                        style={{
                          minWidth: "79px",
                        }}
                      >
                        {isLoadingUpdate ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          <span> {t("global.update")}</span>
                        )}
                        {/* {`${t("global.update")}`} */}
                      </Button>
                      <Button
                        disabled={!!!mappingArray?.length || isLoadingMap}
                        variant="success"
                        className="ms"
                        style={{
                          minWidth: "60px",
                        }}
                        onClick={(e: any) => newMapImportMapping(e)}
                      >
                        {" "}
                        {isLoadingMap ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          <span> {t("global.map")}</span>
                        )}
                      </Button>
                    </Col>{" "}
                    <div className="d-flex justify-content-end">
                      <div className="my-3">
                        <Button
                          disabled={!!!mappingArray?.length || isLoadingImport}
                          variant="info"
                          className="me-1"
                          onClick={(e: any) => {
                            handleImport(e);
                          }}
                          style={{ minWidth: "74px" }}
                        >
                          {isLoadingImport ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              role="status"
                            />
                          ) : (
                            <span> {t("side_bar.import")}</span>
                          )}

                          {/* {`${t("side_bar.import")}`
                          {t("side_bar.import")}
                          } */}
                        </Button>
                        <Button
                          disabled={!!!mappingArray?.length}
                          variant="primary"
                          className="mx"
                          onClick={(e: any) => {
                            handlePreview(e);
                          }}
                        >{`${t("global.preview")}`}</Button>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-4">
                  <div className="col-12  d-flex justify-content-end">
                    <Button
                      variant="success"
                      className="ms-2"
                      onClick={() => handleSave()}
                    >
                      {t("global.markAsComplete")}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
            {showOverview && (
              <div className="row">
                {statsChart?.statisticsHistory?.map(
                  (itemHistory: any, id: number) => (
                    <div className="my-3 col-md-3" style={{ fontSize: "13px" }}>
                      <div>
                        <span className="fw-bold">{t("global.date")}: </span>
                        <span>{formatDate(itemHistory?.createdAt)}</span>
                      </div>
                      <div>
                        <span className="fw-bold">
                          {workflowDataRedux?.copywriters?.length > 1
                            ? "Managers: "
                            : "Manager: "}{" "}
                        </span>
                        <span>
                          {" "}
                          {workflowDataRedux?.copywriters
                            ?.map(
                              (writer: any) =>
                                (writer?.firstName
                                  ? writer?.firstName + " "
                                  : "") + (writer?.lastName ?? "")
                            )
                            .join(", ")}
                        </span>
                      </div>
                      <div>
                        <span className="fw-bold">{t("global.client")}: </span>
                        <span>{workflowDataRedux?.client?.name ?? "-"}</span>
                      </div>
                      <div>
                        <span className="fw-bold">
                          {t("side_bar.products")}:{" "}
                        </span>
                        <span>{itemHistory?.products?.length ?? 0}</span>
                      </div>
                      <div>
                        <span className="fw-bold">
                          {t("side_bar.base_data")}:{" "}
                        </span>
                        <span>{itemHistory?.baseDataHasValue}</span>
                      </div>
                      <div>
                        <span className="fw-bold">
                          {t("side_bar.attributes")}:{" "}
                        </span>
                        <span>{itemHistory?.attributesWithValues}</span>
                      </div>
                      {itemHistory?.contentInfo?.map((info: any) => {
                        return (
                          <div>
                            <span className="fw-bold">
                              {t(`requirement.content_${info?.language}`)}:{" "}
                            </span>
                            <span>
                              {info?.description + info?.intro + info?.bullets}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )
                )}
              </div>
            )}

            <Row>
              <Col>
                {showStats && (
                  <div className="my-3">
                    <h5>{t("importStatistics.importStatistics")}</h5>
                    {importStats.length === 0 && (
                      <div>{t("importStatistics.noStatisticsAvailable")}</div>
                    )}
                    {importStats.map((stat, idx) => {
                      const g = stat.general;
                      const total = g.totalProducts || 1;
                      const createdProducts = total - (g.updatedProducts || 0);
                      const percent = (val: number) =>
                        `${Math.round((val / total) * 100)}%`;

                      return (
                        <Card
                          key={stat.id || idx}
                          className="mb-4 shadow-sm border-0"
                        >
                          <Card.Body>
                            <Row>
                              <Col md={6}>
                                <div className="mb-2">
                                  <strong>{t("importStatistics.date")}:</strong>{" "}
                                  {stat.createdAt
                                    ? new Date(stat.createdAt).toLocaleString()
                                    : "-"}
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.totalProducts")}:
                                  </strong>{" "}
                                  {g.totalProducts}
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.createdProducts")}:
                                  </strong>{" "}
                                  {createdProducts} ({percent(createdProducts)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.updatedProducts")}:
                                  </strong>{" "}
                                  {g.updatedProducts} (
                                  {percent(g.updatedProducts)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.brands")}:
                                  </strong>{" "}
                                  {g.brands} ({percent(g.brands)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.brandsToAdd")}:
                                  </strong>{" "}
                                  {g.brandsToAdd}
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.newProducts")}:
                                  </strong>{" "}
                                  {g.newProducts}
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.sapiIds")}:
                                  </strong>{" "}
                                  {g.sapiIds} ({percent(g.sapiIds)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.sapiIdsToAdd")}:
                                  </strong>{" "}
                                  {g.sapiIdsToAdd}
                                </div>
                              </Col>
                              <Col md={6}>
                                <div>
                                  <strong>
                                    {t("importStatistics.categories")}:
                                  </strong>{" "}
                                  {g.categories} ({percent(g.categories)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.categoriesToAdd")}:
                                  </strong>{" "}
                                  {g.categoriesToAdd}
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.sourceUrls")}:
                                  </strong>{" "}
                                  {g.sourceUrls} ({percent(g.sourceUrls)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.sourceUrlsToAdd")}:
                                  </strong>{" "}
                                  {g.sourceUrlsToAdd}
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.pharmaCodes")}:
                                  </strong>{" "}
                                  {g.pharmaCodes} ({percent(g.pharmaCodes)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.pharmaCodesToAdd")}:
                                  </strong>{" "}
                                  {g.pharmaCodesToAdd}
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.articleNumbers")}:
                                  </strong>{" "}
                                  {g.articleNumbers} (
                                  {percent(g.articleNumbers)})
                                </div>
                                <div>
                                  <strong>
                                    {t("importStatistics.articleNumbersToAdd")}:
                                  </strong>{" "}
                                  {g.articleNumbersToAdd}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col>
                                <div className="d-flex flex-wrap gap-4">
                                  {["de", "en", "fr", "it"].map(
                                    (lang) =>
                                      g[lang] && (
                                        <Card
                                          key={lang}
                                          className="p-2 flex-grow-1"
                                          style={{ minWidth: 200 }}
                                        >
                                          <Card.Title
                                            className="mb-2"
                                            style={{ fontSize: "1rem" }}
                                          >
                                            {t(`languages.${lang}`)}
                                          </Card.Title>
                                          <ul
                                            className="mb-0"
                                            style={{ fontSize: "0.95rem" }}
                                          >
                                            <li>
                                              {t("importStatistics.intros")}:{" "}
                                              {g[lang].intros}
                                            </li>
                                            <li>
                                              {t("importStatistics.titles")}:{" "}
                                              {g[lang].titles}
                                            </li>
                                            <li>
                                              {t("importStatistics.bullets")}:{" "}
                                              {g[lang].bullets}
                                            </li>
                                            <li>
                                              {t("importStatistics.subtitles")}:{" "}
                                              {g[lang].subtitles}
                                            </li>
                                            <li>
                                              {t(
                                                "importStatistics.titlesToAdd"
                                              )}
                                              : {g[lang].titlesToAdd}
                                            </li>
                                            <li>
                                              {t(
                                                "importStatistics.descriptions"
                                              )}
                                              : {g[lang].descriptions}
                                            </li>
                                            <li>
                                              {t(
                                                "importStatistics.subtitlesToAdd"
                                              )}
                                              : {g[lang].subtitlesToAdd}
                                            </li>
                                          </ul>
                                        </Card>
                                      )
                                  )}
                                </div>
                              </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                              {/* here */}
                              <Button
                                size="sm"
                                variant="primary"
                                onClick={() => {
                                  setPreview({
                                    general: stat?.general,
                                    products: stat?.products,
                                  });
                                  setShow(true);
                                }}
                              >
                                {t("importStatistics.showDetails")}
                              </Button>
                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })}
                  </div>
                )}
              </Col>
            </Row>
          </Row>
        </Card.Body>
      </Card>
      {/* ovdje */}
      <Modal show={show} onHide={handleClose} fullscreen={true}>
        <Modal.Body>
          <Tabs defaultActiveKey="table" id="modal-tabs" className="mb-3">
            <Tab eventKey="table" title={t("preview_table.preview_table")}>
              <Table className="table mb-0 table-import">
                <thead className="table-light">
                  <tr>
                    <th className="text-center" scope="col">
                      {`${t("global.action")}`}
                    </th>
                    <th className="text-center" scope="col">{`${t(
                      "global.id"
                    )}`}</th>

                    <th className="text-nowrap text-center" scope="col">{`${t(
                      "products.articleNumber"
                    )}`}</th>
                    <th className="text-center" scope="col">{`${t(
                      "products.eanCode"
                    )}`}</th>
                    <th className="text-center text-nowrap" scope="col">{`${t(
                      "products.sapId"
                    )}`}</th>
                    <th className="text-center text-nowrap" scope="col">{`${t(
                      "products.pharmaCode"
                    )}`}</th>
                    <th className="text-center text-nowrap" scope="col">{`${t(
                      "products.sourceURL"
                    )}`}</th>
                    <th className="text-center" scope="col">{`${t(
                      "products.brand"
                    )}`}</th>
                    <th className="text-center" scope="col">{`${t(
                      "products.category"
                    )}`}</th>
                    <th
                      className="text-center"
                      scope="col"
                      style={{ minWidth: "100px" }}
                    >{`${t("products.attributes")}`}</th>
                    {(translationLanguageEnum as any)?.map((item: any) =>
                      translationValue?.map((transaltion: any) => (
                        <th
                          className="text-center"
                          style={{
                            minWidth:
                              transaltion === "description" ||
                              transaltion === "intro" ||
                              transaltion === "bullets"
                                ? "200px"
                                : "100px",
                          }}
                        >
                          {item} - {capitalizeFirstLetter(transaltion)}
                        </th>
                      ))
                    )}
                  </tr>
                </thead>

                <tbody className="align-middle text-preview text-start">
                  {preview?.products?.map((item: any, index: number) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: item?.id ? "#f8ed62" : "#90EE90",
                      }}
                    >
                      <td>
                        <div style={cellContentStyle}>
                          {item?.id
                            ? `${t("preview_table.updated")}`
                            : `${t("preview_table.created")}`}
                        </div>
                      </td>
                      <td>
                        <div style={cellContentStyle}>{item?.id ?? null}</div>
                      </td>

                      <td
                        style={{
                          backgroundColor: item?.articleNumber
                            ?.isLoadedFromDatabase
                            ? "#f8ed62"
                            : "#90EE90",
                        }}
                      >
                        <div style={cellContentStyle}>
                          {item?.articleNumber?.excelValue}
                        </div>
                      </td>

                      <td
                        style={{
                          backgroundColor: item?.eanCode?.isLoadedFromDatabase
                            ? "#f8ed62"
                            : "#90EE90",
                        }}
                      >
                        <div style={cellContentStyle}>
                          {item?.eanCode?.excelValue}
                        </div>
                      </td>

                      <td
                        style={{
                          backgroundColor: item?.sapId?.isLoadedFromDatabase
                            ? "#f8ed62"
                            : "#90EE90",
                        }}
                      >
                        <div style={cellContentStyle}>
                          {item?.sapId?.excelValue}
                        </div>
                      </td>

                      <td
                        style={{
                          backgroundColor: item?.pharmaCode
                            ?.isLoadedFromDatabase
                            ? "#f8ed62"
                            : "#90EE90",
                        }}
                      >
                        <div style={cellContentStyle}>
                          {item?.pharmaCode?.excelValue}
                        </div>
                      </td>

                      <td
                        style={{
                          backgroundColor: item?.sourceUrl?.isLoadedFromDatabase
                            ? "#f8ed62"
                            : "#90EE90",
                        }}
                      >
                        <div style={cellContentStyle}>
                          {item?.sourceUrl?.excelValue}
                        </div>
                      </td>

                      <td
                        style={{
                          backgroundColor: item?.brand?.isLoadedFromDatabase
                            ? "#f8ed62"
                            : "#90EE90",
                        }}
                      >
                        <div style={cellContentStyle}>
                          {item?.brand?.excelValue?.name}
                        </div>
                      </td>

                      <td
                        style={{
                          backgroundColor: item?.category?.isLoadedFromDatabase
                            ? "#f8ed62"
                            : "#90EE90",
                          minWidth: "150px",
                        }}
                      >
                        <div style={cellContentStyle}>
                          {item?.category?.excelValue?.translations?.map(
                            (category: any, i: number) => (
                              <span key={i} className="d-block">
                                {category?.lang +
                                  "- " +
                                  (category?.title ?? "")}
                              </span>
                            )
                          )}
                        </div>
                      </td>

                      <td>
                        <div style={cellContentStyle}>
                          {item?.attributes?.map((attribute: any, i: number) =>
                            attribute?.values?.map((value: any, j: number) => (
                              <span key={`${i}-${j}`} className="d-block">
                                {attribute?.language + "- " + value}
                              </span>
                            ))
                          )}
                        </div>
                      </td>

                      {functionForCorrectFields(item)}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab>

            <Tab eventKey="text" title={t("preview_table.preview_statistics")}>
              <div className="p-3">
                {preview?.general ? (
                  <Card className="shadow-sm border-0">
                    <Card.Body>
                      <Row>
                        <Col md={6}>
                          <div>
                            <strong>
                              {t("importStatistics.totalProducts")}:
                            </strong>{" "}
                            {preview.general.totalProducts}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.createdProducts")}:
                            </strong>{" "}
                            {preview.general.totalProducts -
                              (preview.general.updatedProducts ?? 0)}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.updatedProducts")}:
                            </strong>{" "}
                            {preview.general.updatedProducts}
                          </div>
                          <div>
                            <strong>{t("importStatistics.brands")}:</strong>{" "}
                            {preview.general.brands}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.brandsToAdd")}:
                            </strong>{" "}
                            {preview.general.brandsToAdd}
                          </div>
                          <div>
                            <strong>{t("importStatistics.sapiIds")}:</strong>{" "}
                            {preview.general.sapiIds}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.sapiIdsToAdd")}:
                            </strong>{" "}
                            {preview.general.sapiIdsToAdd}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.newProducts")}:
                            </strong>{" "}
                            {preview.general.newProducts}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div>
                            <strong>{t("importStatistics.categories")}:</strong>{" "}
                            {preview.general.categories}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.categoriesToAdd")}:
                            </strong>{" "}
                            {preview.general.categoriesToAdd}
                          </div>
                          <div>
                            <strong>{t("importStatistics.sourceUrls")}:</strong>{" "}
                            {preview.general.sourceUrls}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.sourceUrlsToAdd")}:
                            </strong>{" "}
                            {preview.general.sourceUrlsToAdd}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.pharmaCodes")}:
                            </strong>{" "}
                            {preview.general.pharmaCodes}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.pharmaCodesToAdd")}:
                            </strong>{" "}
                            {preview.general.pharmaCodesToAdd}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.articleNumbers")}:
                            </strong>{" "}
                            {preview.general.articleNumbers}
                          </div>
                          <div>
                            <strong>
                              {t("importStatistics.articleNumbersToAdd")}:
                            </strong>{" "}
                            {preview.general.articleNumbersToAdd}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col>
                          <div className="d-flex flex-wrap gap-4">
                            {["de", "en", "fr", "it"].map((lang) =>
                              preview.general[lang] ? (
                                <Card
                                  key={lang}
                                  className="p-2 flex-grow-1"
                                  style={{ minWidth: 200 }}
                                >
                                  <Card.Title
                                    className="mb-2"
                                    style={{ fontSize: "1rem" }}
                                  >
                                    {t(`languages.${lang}`)}
                                  </Card.Title>
                                  <ul
                                    className="mb-0"
                                    style={{ fontSize: "0.95rem" }}
                                  >
                                    <li>
                                      {t("importStatistics.intros")}:{" "}
                                      {preview.general[lang].intros}
                                    </li>
                                    <li>
                                      {t("importStatistics.titles")}:{" "}
                                      {preview.general[lang].titles}
                                    </li>
                                    <li>
                                      {t("importStatistics.bullets")}:{" "}
                                      {preview.general[lang].bullets}
                                    </li>
                                    <li>
                                      {t("importStatistics.subtitles")}:{" "}
                                      {preview.general[lang].subtitles}
                                    </li>
                                    <li>
                                      {t("importStatistics.titlesToAdd")}:{" "}
                                      {preview.general[lang].titlesToAdd}
                                    </li>
                                    <li>
                                      {t("importStatistics.descriptions")}:{" "}
                                      {preview.general[lang].descriptions}
                                    </li>
                                    <li>
                                      {t("importStatistics.subtitlesToAdd")}:{" "}
                                      {preview.general[lang].subtitlesToAdd}
                                    </li>
                                  </ul>
                                </Card>
                              ) : null
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ) : (
                  <div>{t("importStatistics.noStatisticsAvailable")}</div>
                )}
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>

        <Modal.Footer className="d-flex align-items-center justify-content-end">
          <Button variant="secondary" onClick={handleClose}>
            {t(`modals.close`)}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
